import { render, staticRenderFns } from "./PesagensRegistradasPennState.vue?vue&type=template&id=308292b1&"
import script from "./PesagensRegistradasPennState.vue?vue&type=script&lang=js&"
export * from "./PesagensRegistradasPennState.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports